import React from 'react';
import { Content, Pane, Text } from '@leverege/ui-elements';
import ViewerModel from "../../dataViewers/layout/ViewerModel.js";
import Blocker from "../../views/blocker/Blocker.js";
import Swipe from "../../views/swipe/Swipe.js";
import { rdvm, rhdv } from "../../dataViewers/Util.js";
import AbstractItemInfoScreen, { connectChild } from "./AbstractItemInfoScreen.js";
import LayoutSelector from "../../dataViewers/layout/MobileLayoutSelector.js";
import S from './MobileItemInfoScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class MobileItemInfoScreen extends AbstractItemInfoScreen {
  constructor(props) {
    super(props);
    this.mobile = true;
    this.matchContext.mobile = true;
    this.dataViewers.context.mobile = true;
    this.actionsMatchContext = {
      data: {
        ...this.matchContext,
        use: 'mobileActionBar'
      }
    };
  }
  componentDidMount(props) {
    const {
      setActionsContext,
      setActionsMatchContext
    } = this.props;
    this.setTitle();
    if (setActionsContext) {
      setActionsContext({
        data: this.getContext()
      });
    }
    if (setActionsMatchContext) {
      setActionsMatchContext(this.actionsMatchContext);
    }
  }
  setTitle = () => {
    const {
      setIcon,
      setTitle
    } = this.props;
    if (setIcon) {
      setIcon({
        data: this.getIcon()
      });
    }
    if (!setIcon && setTitle) {
      setTitle({
        data: /*#__PURE__*/_jsx(Text, {
          variant: "mobileScreenTitle|screenTitle",
          icon: this.getIcon(),
          children: this.getTitle()
        })
      });
    } else if (setTitle) {
      setTitle({
        data: this.getTitle()
      });
    }
  };
  componentDidUpdate(prevProps, prevState) {
    const {
      item,
      setActionsContext
    } = this.props;
    const {
      item: pItem
    } = prevProps;
    const {
      modifiedLayout
    } = this.state;
    const {
      modifiedLayout: pModifiedLayout
    } = prevState;
    if (item !== pItem || modifiedLayout !== pModifiedLayout) {
      setActionsContext({
        data: this.getContext()
      });
      this.setTitle();
    }
  }
  render() {
    return /*#__PURE__*/_jsx(Blocker, {
      matchContext: this.matchContext,
      context: this.props,
      render: this.renderChildren
    });
  }
  renderChildren = () => {
    const {
      item,
      settings,
      settingsPath
    } = this.props;
    const {
      modifiedLayout
    } = this.state;
    const currLayout = modifiedLayout || settings || {};
    const {
      layout = 'vh',
      main1,
      main2,
      aux1,
      aux2
    } = currLayout;

    // const matchContext = { use : 'navBar', client, path }
    const dataItems = this.cache.calc('items', this.createDataItems, item);
    this.paginator.setData(dataItems);
    const dvp = this.getDataViewerProps();
    const hiddenDataViewers = this.getHiddenDataViewers();
    const cAux1 = rdvm(aux1, dvp, {
      settingsPath,
      settingsData: 'setAux1Settings',
      vertical: false
    });
    const cAux2 = rdvm(aux2, dvp, {
      settingsPath,
      settingsData: 'setAux2Settings',
      vertical: false
    });
    const cMain1 = rdvm(main1, dvp, {
      settingsPath,
      settingsData: 'setMain1Settings'
    });
    const cMain2 = rdvm(main2, dvp, {
      settingsPath,
      settingsData: 'setMain2Settings'
    });
    const hasSplit = cMain1 && cMain2;
    return /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsx(Pane, {
          variant: "mobileItemHeader",
          layout: "flex:mobileItemHeader|rowM",
          style: {
            alignItems: 'center'
          },
          children: /*#__PURE__*/_jsx(LayoutSelector, {
            context: this.getContext()
          })
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        children: /*#__PURE__*/_jsxs(Content, {
          horizontal: layout[0] === 'h',
          children: [cAux1 && /*#__PURE__*/_jsx(Content.Header, {
            children: cAux1
          }), /*#__PURE__*/_jsxs(Content.Area, {
            children: [!hasSplit && (cMain1 || cMain2), hasSplit && /*#__PURE__*/_jsx(Swipe, {
              ref: r => {
                this.splitPane = r;
              },
              topLocation: "100%",
              middleLocation: "40%",
              background: cMain1,
              overlay: cMain2,
              mode: "swipe"
            })]
          }), cAux2 && /*#__PURE__*/_jsx(Content.Footer, {
            children: cAux2
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: S.hiddenDataViewers,
        children: hiddenDataViewers.map(dataViewer => rhdv(dataViewer, dvp))
      })]
    });
  };
}
export default connectChild(MobileItemInfoScreen, {
  clientType: 'MobileItemInfoScreen'
}, ViewerModel);